<template>
  <div class="sapceLeft search-item date-input" @click="chooseDate">
    <span class="label">{{ label }}:</span>
    <span class="date-show">
      <span v-if="dateVal">{{ dateVal }}</span>
      <span v-else>All</span>
    </span>
    <div class="date-oper">
      <el-date-picker
        :ref="id"
        value-format="yyyy-MM"
        v-model="dateVal"
        type="month"
        :clearable="false"
        placeholder="All"
      >
      </el-date-picker>
    </div>
    <i class="el-icon-circle-close date-close" @click.stop="clearVal()" />
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    label: {
      type: String,
      default: () => {
        return "label";
      },
    },
  },
  data() {
    return {
      id: "searchDate" + new Date().getTime,
      dateVal: "",
    };
  },
  methods: {
    chooseDate() {
      this.$refs[this.id].focus();
    },
    clearVal() {
      this.dateVal = "";
    },
  },
  watch: {
    dateVal(newVal) {
      if (newVal) {
        let val = moment(newVal).format("yyyyMM");
        this.$emit("valChange", val.substring(2));
      } else {
        this.$emit("valChange", undefined);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.date-input {
  position: relative;
  overflow: hidden;
  padding-right: 0.24rem;

  &:hover {
    .date-close {
      visibility: inherit;
    }
  }
  .date-oper {
    width: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
  }
  .date-show {
    font-size: 0.16rem;
    color: #000000;
  }
  .date-close {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -0.09rem;
    visibility: hidden;
  }
  .el-input--medium .el-input__inner {
    border: none;
  }
  .el-date-editor.el-input {
    width: 1.8rem;
  }
}

.label {
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.18rem;
  display: inline-block;
  height: 0.46rem;
  line-height: 0.46rem;
}
</style>
